/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LookupKeyEnum,
    LookupKeyEnumFromJSON,
    LookupKeyEnumFromJSONTyped,
    LookupKeyEnumToJSON,
} from './LookupKeyEnum';

/**
 * 
 * @export
 * @interface UpdateCampaignLinkDto
 */
export interface UpdateCampaignLinkDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignLinkDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignLinkDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCampaignLinkDto
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof UpdateCampaignLinkDto
     */
    validFrom: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateCampaignLinkDto
     */
    validTo: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignLinkDto
     */
    affiliateCode: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCampaignLinkDto
     */
    trialDays: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignLinkDto
     */
    couponId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCampaignLinkDto
     */
    firstPurchaseOnly: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCampaignLinkDto
     */
    allowPaymentWithoutCreditCard: boolean;
    /**
     * 
     * @type {LookupKeyEnum}
     * @memberof UpdateCampaignLinkDto
     */
    preferredLookupKey: LookupKeyEnum | null;
    /**
     * 
     * @type {Array<LookupKeyEnum>}
     * @memberof UpdateCampaignLinkDto
     */
    allowedLookupKeys: Array<LookupKeyEnum>;
}

export function UpdateCampaignLinkDtoFromJSON(json: any): UpdateCampaignLinkDto {
    return UpdateCampaignLinkDtoFromJSONTyped(json, false);
}

export function UpdateCampaignLinkDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCampaignLinkDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'slug': json['slug'],
        'name': json['name'],
        'isActive': json['isActive'],
        'validFrom': (json['validFrom'] === null ? null : new Date(json['validFrom'])),
        'validTo': (json['validTo'] === null ? null : new Date(json['validTo'])),
        'affiliateCode': json['affiliateCode'],
        'trialDays': json['trialDays'],
        'couponId': json['couponId'],
        'firstPurchaseOnly': json['firstPurchaseOnly'],
        'allowPaymentWithoutCreditCard': json['allowPaymentWithoutCreditCard'],
        'preferredLookupKey': LookupKeyEnumFromJSON(json['preferredLookupKey']),
        'allowedLookupKeys': ((json['allowedLookupKeys'] as Array<any>).map(LookupKeyEnumFromJSON)),
    };
}

export function UpdateCampaignLinkDtoToJSON(value?: UpdateCampaignLinkDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'slug': value.slug,
        'name': value.name,
        'isActive': value.isActive,
        'validFrom': (value.validFrom === null ? null : value.validFrom.toISOString()),
        'validTo': (value.validTo === null ? null : value.validTo.toISOString()),
        'affiliateCode': value.affiliateCode,
        'trialDays': value.trialDays,
        'couponId': value.couponId,
        'firstPurchaseOnly': value.firstPurchaseOnly,
        'allowPaymentWithoutCreditCard': value.allowPaymentWithoutCreditCard,
        'preferredLookupKey': LookupKeyEnumToJSON(value.preferredLookupKey),
        'allowedLookupKeys': ((value.allowedLookupKeys as Array<any>).map(LookupKeyEnumToJSON)),
    };
}

